import { PropsWithChildren } from 'react';
import classnames from 'classnames';
import { CheckIcon } from 'lucide-react';

import styles from './select.module.scss';

export type SelectItemType = {
    id: string | number;
    label: string;
    supportingText?: string;
    selected?: boolean;
};

export type SelectItemProps = PropsWithChildren & {
    id: string | number;
    supportingText?: string;
    disabled?: boolean;
};

const SelectItem = ({
    id,
    children,
    supportingText,
    disabled,
}: SelectItemProps) => (
    <li
        data-key={id}
        role="option"
        className={classnames({
            [styles.listItem]: true,
            [styles.disabled]: disabled,
        })}
        data-disabled={disabled}
    >
        <div className={styles.content}>
            <label>{children}</label>
            <SupportingText text={supportingText} />
        </div>
        <CheckIcon size={18} color="#7358ff" strokeWidth={2} />
    </li>
);

const SupportingText = ({ text }: { text?: string }) => {
    if (!text) return <></>;
    return <span className={styles.supportingText}>{text}</span>;
};

export { SelectItem };
